module.exports = "<a href=\"#\">{{$ctrl.label}}</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpLink/adpLink.html
// module id = 525
// module chunks = 0